export default function(state = [], action) {
  switch (action.type) {
    case "EARNINGS_SELECTED_FILTERS":
      return action.payload;
    default:
      return state;
  }
}
